import Vue from "vue";
import Router from "vue-router";

import Layout from "@/pages/layout/index";
import Login from "@/pages/login/login.vue";
import SystemSetting from "@/pages/system-setting";

Vue.use(Router);

export const Menuroutes = [
  {
    path: "/",
    component: Layout,
    name: "Layout",
    redirect: "data-overview",
    meta: {
      title: "代理后台",
      icon: "el-icon-menu",
      showMenu: true,
    },
    children: [
      {
        path: "data-overview",
        name: "dataOverview",
        meta: {
          title: "数据概览",
          icon: "el-icon-s-data",
          showMenu: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "dataOverview" */ "@/pages/data-overview"
          ),
      },
      {
        path: "agency-list",
        name: "agencyList",
        meta: {
          title: "代理列表",
          icon: "el-icon-s-custom",
          showMenu: true,
        },
        component: () =>
          import(/* webpackChunkName: "agencyList" */ "@/pages/agency-list"),
      },
      {
        path: "user-list",
        name: "userList",
        meta: {
          title: "会员列表",
          icon: "el-icon-user-solid",
          showMenu: true,
        },
        component: () =>
          import(/* webpackChunkName: "userList" */ "@/pages/user-list"),
      },
      {
        path: "commission-report",
        name: "commissionReport",
        meta: {
          title: "佣金报表",
          icon: "el-icon-tickets",
          showMenu: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "commissionReport" */ "@/pages/commission-report"
          ),
      },
      {
        path: "source-mange",
        name: "sourceMange",
        meta: {
          title: "渠道管理",
          icon: "el-icon-notebook-1",
          showMenu: true,
        },
        component: () =>
          import(/* webpackChunkName: "sourceMange" */ "@/pages/source-mange"),
      },
      {
        path: "system-setting",
        name: "systemSetting",
        meta: {
          title: "系统管理",
          icon: "el-icon-setting",
          showMenu: true,
        },
        redirect: "/system-setting/account-manage",
        component: SystemSetting,

        children: [
          {
            path: "account-manage",
            name: "accountManage",
            meta: {
              title: "账户管理",
              icon: "el-icon-user",
              showMenu: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "account-manage" */ "@/pages/account-manage"
              ),
          },
          {
            path: "access-manage",
            name: "accessManage",
            meta: {
              title: "权限管理",
              icon: "el-icon-tickets",
              showMenu: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "access-manage */ "@/pages/access-manage"
              ),
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    component: Login,
    name: "Login",
    meta: {
      title: "登录",
      showMenu: false,
    },
  },
];

export const DynamicRoutes = [
  {
    path: "/",
    component: Layout,
    name: "Layout",
    redirect: "data-overview",
    meta: {
      title: "代理后台",
      icon: "el-icon-menu",
      showMenu: true,
    },
    children: [
      {
        path: "data-overview",
        name: "dataOverview",
        meta: {
          title: "数据概览",
          icon: "el-icon-s-data",
          showMenu: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "dataOverview" */ "@/pages/data-overview"
          ),
      },
      {
        path: "agency-list",
        name: "agencyList",
        meta: {
          title: "代理列表",
          icon: "el-icon-s-custom",
          showMenu: true,
        },
        component: () =>
          import(/* webpackChunkName: "agencyList" */ "@/pages/agency-list"),
      },
      {
        path: "user-list",
        name: "userList",
        meta: {
          title: "会员列表",
          icon: "el-icon-user-solid",
          showMenu: true,
        },
        component: () =>
          import(/* webpackChunkName: "userList" */ "@/pages/user-list"),
      },
      {
        path: "commission-report",
        name: "commissionReport",
        meta: {
          title: "佣金报表",
          icon: "el-icon-tickets",
          showMenu: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "commissionReport" */ "@/pages/commission-report"
          ),
      },
      {
        path: "source-mange",
        name: "sourceMange",
        meta: {
          title: "渠道管理",
          icon: "el-icon-notebook-1",
          showMenu: true,
        },
        component: () =>
          import(/* webpackChunkName: "sourceMange" */ "@/pages/source-mange"),
      },
      {
        path: "system-setting",
        name: "systemSetting",
        meta: {
          title: "系统管理",
          icon: "el-icon-setting",
          showMenu: true,
        },
        redirect: "/system-setting/account-manage",
        component: SystemSetting,

        children: [
          {
            path: "account-manage",
            name: "accountManage",
            meta: {
              title: "账户管理",
              icon: "el-icon-user",
              showMenu: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "account-manage" */ "@/pages/account-manage"
              ),
          },
          {
            path: "access-manage",
            name: "accessManage",
            meta: {
              title: "权限管理",
              icon: "el-icon-tickets",
              showMenu: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "access-manage */ "@/pages/access-manage"
              ),
          },
        ],
      },
    ],
  },
];

export default new Router({
  mode: "hash",
  routes:[
    {
      path: "/login",
      component: Login,
      name: "Login",
      meta: {
        title: "登录",
        showMenu: false,
      },
    },
  ],
});
